module.exports = __webpack_public_path__ + "img/lock_clock_opsz20B.795a99e0.svg";